var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"document-link text-uppercase"},[_vm._v("\n  "+_vm._s(_vm.filetype)+" "),(_vm.filesize !== '')?_c('span',[_vm._v("|")]):_vm._e(),_vm._v(" "+_vm._s(_vm.filesize)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }